konnyScript(function($){
    $('.bw1stWrap .notiBox .notiTit').click(function(){
        var notiBox = $(this).parent('.notiBox');
        if(notiBox.hasClass('on')){
          notiBox.removeClass('on');
        }else{
          notiBox.addClass('on');
        }
    });

    if($('#bw1stFixBt').length > 0){
        var fixBtOffset = $('#bw1stFixBt').offset();

        var vHeight=$(window).height();

        var fixPar1 = parseInt(fixBtOffset.top / vHeight);
        var fixPar2 = fixBtOffset.top % vHeight;

        var footerOffset = $('.footer').offset();
        var fixPar3 = footerOffset.top - vHeight;

        if(fixPar1 == 0){
            if($(document).scrollTop() > fixPar3 ){
              $('#bw1stFixBt').removeClass('fix');
            }else if( $(document).scrollTop() > 0 ){
              $('#bw1stFixBt').addClass('fix');
            }else{
              $('#bw1stFixBt').removeClass('fix');
            }
        }else{
            if($(document).scrollTop() > fixPar3 ){
              $('#bw1stFixBt').removeClass('fix');
            }else if( $(document).scrollTop() > vHeight*fixPar1 ){
              $('#bw1stFixBt').addClass('fix');
            }else{
              $('#bw1stFixBt').removeClass('fix');
            }
        }

        $(window).scroll(function(){
            if(fixPar1 == 0){
              if($(document).scrollTop() > fixPar3 ){
                  $('#bw1stFixBt').removeClass('fix');
              }else if( $(document).scrollTop() > 0 ){
                  $('#bw1stFixBt').addClass('fix');
              }else{
                  $('#bw1stFixBt').removeClass('fix');
              }
            }else{
              if($(document).scrollTop() > fixPar3 ){
                  $('#bw1stFixBt').removeClass('fix');
              }else if( $(document).scrollTop() > vHeight*fixPar1 ){
                  $('#bw1stFixBt').addClass('fix');
              }else{
                  $('#bw1stFixBt').removeClass('fix');
              }
            }
        });
    }
});